<template>
  <div class="Purpose">
    <!-- Display text only if it is 10 feet -->
    <div class="tenfeet" v-if="checkTenFoot()">
      <p style="color: #6dbe45">*10ft containers cannot be shipped</p>
    </div>
    <div>
      <!-- Radio Buttons -->
      <div id="purposeselection">
        <label class="grow">
          <input
            type="radio"
            id="STORAGE"
            value="STORAGE"
            v-model="bind_Purpose"
            v-on:change="submitted()"
          />
          <img :src="img_storage" alt="Storage logo" width="80%" />
        </label>
        <label class="grow" v-if="!checkTenFoot()">
          <input
            type="radio"
            id="EXPORT"
            value="EXPORT"
            v-model="bind_Purpose"
            v-on:change="submitted()"
            :disabled="checkTenFoot()"
          />
          <img :src="img_export" alt="Export logo" width="80%" />
        </label>
      </div>
      <!-- checkbox -->
      <div class="row justify-content-center" v-if="purpose === 'EXPORT'">
        <div
          class="col-xs-12 col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3"
        >
          <div class="form-group">
            <label for="tnc" style="padding: -5px">
              <input type="checkbox" id="cscsurvey" v-model="bind_CSCTerms" />
              <a
                style="color: white; font-size: 18px"
                @click.stop="dialog = true"
              >
                &nbsp;Add a
                <a
                  style="color: #6dbe45; font-size: 18px"
                  target="_blank"
                  :href="CSCSurveyHref"
                  >CSC Survey</a
                >
                <small style="color: white; font-size: 12px; float: left"
                  >Please add an additional 2-3 business days for CSC surveys to
                  be completed: 4-6 business days for customer pick-up, and 6-10
                  business days for ground level delivery (we recommend
                  surveying all containers being used for shipment).</small
                >
              </a>
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as country_based_data from "@/JS/CountryBasedData";
import { mapGetters, mapActions } from "vuex";
import * as types from "@/store/types";

export default {
  name: "Purpose",
  data() {
    return {
      dialog: false,
      img_storage_selected:
        "https://images-wcs.s3-us-west-2.amazonaws.com/Container-Storage-Checked.png",
      img_storage_not_selected:
        "https://images-wcs.s3-us-west-2.amazonaws.com/Container-Storage-UnChecked.png",
      img_storage:
        "https://images-wcs.s3-us-west-2.amazonaws.com/Container-Storage-Checked.png",
      img_export_selected:
        "https://images-wcs.s3-us-west-2.amazonaws.com/Container-for-Export-Checked.png",
      img_export_not_selected:
        "https://images-wcs.s3-us-west-2.amazonaws.com/Container-for-Export-UnChecked.png",
      img_export:
        "https://images-wcs.s3-us-west-2.amazonaws.com/Container-for-Export-UnChecked.png",
      CSCSurveyHref: "",
    };
  },
  mounted() {
    if (this.purpose === "STORAGE") {
      this.img_storage = this.img_storage_selected;
      this.img_export = this.img_export_not_selected;
    } else if (this.purpose === "EXPORT") {
      this.img_export = this.img_export_selected;
      this.img_storage = this.img_storage_not_selected;
    }
    this.initializeCountryBasedHref(); //Assign CSCSURVEY URL for USA/Canada
  },
  computed: {
    ...mapGetters({
      COUNTRY_CODE: types.COUNTRYCODE,
      purpose: types.PURPOSE,
      cscTerms: types.CSC_TERMS,
      CART: types.CART_LIST,
      currentSurveyObject: types.CURRENTSURVEYOBJECT,
    }),
    bind_Purpose: {
      get() {
        return this.purpose;
      },
      set(value) {
        this.updatePurpose(value);
      },
    },
    bind_CSCTerms: {
      get() {
        return this.cscTerms;
      },
      set(value) {
        this.updateCscTerms(value);
      },
    }
  },
  methods: {
    ...mapActions({
      updatePurpose: types.ACTIONS_UPDATE_PURPOSE,
      updateDelivery: types.ACTIONS_UPDATE_DELIVERY,
      updateCscTerms: types.ACTIONS_UPDATE_CSC_TERMS,
    }),
    initializeCountryBasedHref() {
      if (this.COUNTRY_CODE === "US")
        this.CSCSurveyHref = country_based_data.USACSCSurveyLink;
      else if (this.COUNTRY_CODE === "CA")
        this.CSCSurveyHref = country_based_data.CanadaCSCSurveyLink;
    },
    submitted() {
      //Change delivery type back to DELIVERY, If EXPORT is selected, pre select self-pickup
      //Change is only done when the cart is empty
      if (this.CART.length === 0) {
        if (this.purpose === "STORAGE") this.updateDelivery("DELIVERY");
        else if (this.purpose === "EXPORT") this.updateDelivery("PICK-UP");
      }
    },
    checkTenFoot() {
      //Display Storage Only
      return this.currentSurveyObject.description.includes("10");
    },
  },
  watch: {
    //watcher on vuex type and change the image accordingly
    purpose: function (newValue) {
      if (newValue === "STORAGE") {
        this.img_storage = this.img_storage_selected;
        this.img_export = this.img_export_not_selected;
      } else if (newValue === "EXPORT") {
        this.img_export = this.img_export_selected;
        this.img_storage = this.img_storage_not_selected;
      }
    },
  },
};
</script>

<style scoped>
input[type="radio"] {
  display: none;
}

input[type="radio"]:checked + img {
  border: 5px solid #6dbe45;
}

[type="radio"] + img {
  cursor: pointer;
  border-radius: 10px;
}

a {
  font-size: 20px;
}

input[type="checkbox"] {
  width: 18px;
  height: 18px;
}

.tenfeet {
  font-size: 20px;
  color: red;
}

.img-wrapper {
  position: relative;
  width: 82%;
  font-size: 0;
  border-radius: 10px;
}

.img-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(128, 128, 128, 0.5);
  border-radius: 10px;
}

.img-wrapper img {
  width: 100%;
}
</style>
